import React from 'react'
import { Box, Tooltip, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"


export default function priceComparisonColumn() {

	const iconMap = {
		"More expensive": "chart-line-up",
		"Cheaper": "chart-line-down",
		"Cheaper/More expensive": "chart-line-up-down",
		"$": "money-bills",
		"%": "percent"
	}
	const colorMap = {
		"More expensive": dsColorNew.successText,
		"Cheaper": dsColorNew.dangerRed,
		"Cheaper/More expensive": dsColorNew.noteAmber,
		"$": dsColorNew.successText,
		"%": dsColorNew.black
	}

	return {
		name: 'comparatorValue',
		label: "Condition",
		options: {
			customBodyRowRenderLite: (value, { comparatorName, comparatorUnitName }) => <Box
				sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
				<Tooltip title="Amount" placement="top" arrow>
					<Typography sx={{ fontWeight: "bold" }}>{value}</Typography>
				</Tooltip>
				<IconSeeker
					tooltip={comparatorUnitName === "$" ? "Currency" : "Percentage"}
					icon={iconMap[comparatorUnitName]}
					sx={{
						mx: .7,
						fontSize: 14,
						color: colorMap[comparatorUnitName]
					}}
				/>
				<IconSeeker
					tooltip={comparatorName}
					icon={iconMap[comparatorName]}
					sx={{ fontSize: 14, color: colorMap[comparatorName] }}
				/>
			</Box>
		}
	}
}